export default __webpack_public_path__ + "static/media/blog-demo.231b0199.gif";